import { render } from "./FormFaq.vue?vue&type=template&id=1c18cd5a&scoped=true"
import script from "./FormFaq.vue?vue&type=script&lang=js"
export * from "./FormFaq.vue?vue&type=script&lang=js"

import "./FormFaq.vue?vue&type=style&index=0&id=1c18cd5a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c18cd5a"]])

export default __exports__